'use client';

import { useUser } from '@clerk/nextjs';
import { useEffect } from 'react';
import { logError, onTracardiProfileId } from '~/utils';

// Fills the id once, for users with none, such as migrated users. Never overwrites: each device has
// its own Tracardi id, and Tracardi keeps old ids on merged profiles, so the first one stays traceable.
export const SaveTracardiProfileId = () => {
  const { user } = useUser();

  useEffect(() => {
    if (!user || user.unsafeMetadata.tracardi_profile_id) return;
    // Stops a callback still queued for an older `user` writing back its stale metadata.
    let active = true;
    onTracardiProfileId((tracardiProfileId: string) => {
      if (!active) return;
      user
        .update({ unsafeMetadata: { ...user.unsafeMetadata, tracardi_profile_id: tracardiProfileId } })
        .catch(logError);
    });
    return () => {
      active = false;
    };
  }, [user]);

  return null;
};
